import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { fillControlClass } from '@next-adapter/generators/form/form-shared/fill-control-class.js'
import { formLabel } from '@next-adapter/generators/form/form-shared/form-label.js'
import { labelWithDescription } from '@next-adapter/generators/form/form-shared/label-with-description.js'
import { renderRichtextFieldRenderer } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-richtext-field.js'
import { defaultValueFromSourceHandler } from './default-value-from-source-handler.js'
import { fillFormItemProps } from './fill-form-item-props.js'

export function renderRichtextField(
  field: SchemaField,
  indent: string,
  label: string,
  hintJSX: string,
  context: FieldRenderContext
): string {
  const defaultValueFromHandler = defaultValueFromSourceHandler(field, context)
  const onChange = defaultValueFromHandler
    ? renderRichtextFieldRenderer({
        kind: 'renderRichtextFieldChangeHandlerTemplate',
        props: {
          indent: indent,
          defaultValueFromHandler: defaultValueFromHandler
        }
      })
    : 'formField.onChange'
  return renderRichtextFieldRenderer({
    kind: 'renderRichtextFieldFormFieldTemplate',
    props: {
      indent: indent,
      fieldName: field.name,
      fillFormItemProps: fillFormItemProps(field),
      labelWithDescription: labelWithDescription(
        formLabel(field, label),
        hintJSX,
        `${indent}      `
      ),
      onChange: onChange,
      fillControlClass: fillControlClass(field, 'min-h-[300px]'),
      toLowerCase: label.toLowerCase()
    }
  })
}
